$eve_app_page_components_slider $eve_app_page_sb_page
	title \Slider
	Head null
	body /
		<= Overview_page $eve_app_page_sb_page
			title null
			body /
				<= Playground $eve_app_page_sb_playground
					component_name \Live_slider
					default_source \
						\Live_slider $eve_slider
						\	label \Volume
						\	value? 40
						\	min 0
						\	max 100
						\	step 5
						\
